import { HttpContext, HttpContextToken } from "@angular/common/http";
import { saneDate } from "app/common/utils";

// Date conversion for the generated API client

/** Skips AutoDateConversionInterceptor, as the generated API client converts its own dates */
export const SKIP_AUTO_DATE_CONVERSION = new HttpContextToken<boolean>(() => false);

export function skipAutoDateConversion(context?: HttpContext) {
    return (context ?? new HttpContext()).set(SKIP_AUTO_DATE_CONVERSION, true);
}

/** Parses an OpenAPI `date-time` value */
export function parseDateTime(value: string) {
    return new Date(value);
}

/** Parses an OpenAPI `date` value (YYYY-MM-DD) as midnight in the local timezone */
export function parseDateOnly(value: string) {
    const [year, month, day] = value.split("-").map(Number) as [number, number, number];
    return saneDate(year, month, day);
}
